import { Component, OnInit, forwardRef, Inject, Input } from '@angular/core';
import { ContractorSelectionActivity } from 'src/app/models/activities/contractor-selection-activity';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';
import { ContractorService, ValidationService } from 'src/app/services';
import { Contractor, Client, Contact } from 'src/app/models';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  AbstractControl,
  Validators
} from '@angular/forms';
import { SelectContractorDataEntity } from 'src/app/models/data-entities/select-contractor-data-entity';

@Component({
    selector: 'wm-contractor-selection-activity-view',
    templateUrl: './contractor-selection-activity-view.component.html',
    styleUrls: ['./contractor-selection-activity-view.component.css'],
    standalone: false
})
export class ContractorSelectionActivityViewComponent extends ActivityView
  implements OnInit {
  form: UntypedFormGroup;
  @Input() showGoBackToList = true;
  activity: ContractorSelectionActivity;
  dataEntity: SelectContractorDataEntity;

  constructor(
    @Inject(forwardRef(() => ContractorService))
    public _contractorSvc: ContractorService,
    private fb: UntypedFormBuilder
  ) {
    super();
  }

  ngOnInit() {
    const de = new SelectContractorDataEntity();

    de.templateCode = 'SELECT_CONTRACTOR';
    de.canEditContractor = this.activity.canEditContractor;
    de.allowNotListedOption = this.activity.model.allowNotListedOption;
    de.contractorTypeIds = this.activity.contractorTypeIds;
    de.parentActivity = this.activity;
    de.isRequired = true;
    de.isVisible = true;
    de.showLabel = false;
    de.contractor = this.activity.contractor;

    this.dataEntity = de;
  }
}
